import React, { ReactNode } from 'react'
import { Modal, Box, Grid, Button } from '@mui/material'
import problema from '../../images/Problema.jpg'
import sucesso from '../../images/Sucesso.jpg'
import ProgressBar from '../ProgressBar'
import { NotificationTypeEnumerated } from '../../interfaces/notificationTypeEnumerated'
import Icon from '@mdi/react'
import { mdiThumbUp } from '@mdi/js'

interface ModalToastProps {
  open: boolean
  title: string | ''
  text: ReactNode | ''
  type: NotificationTypeEnumerated
  duration: number
  onClose: () => void
}

const ModalToast: React.FC<ModalToastProps> = ({ open, title, text, type, duration, onClose }) => {
  const typeToImageMap: Record<NotificationTypeEnumerated, string> = {
    [NotificationTypeEnumerated.SUCCESS]: sucesso,
    [NotificationTypeEnumerated.DANGER]: problema,
    [NotificationTypeEnumerated.INFO]: problema,
    [NotificationTypeEnumerated.WARNING]: problema,
  }

  const typeToColorMap: Record<NotificationTypeEnumerated, string> = {
    [NotificationTypeEnumerated.SUCCESS]: '#80350E',
    [NotificationTypeEnumerated.DANGER]: '#871212',
    [NotificationTypeEnumerated.INFO]: '#2196f3',
    [NotificationTypeEnumerated.WARNING]: '#ff9800',
  }

  const typeToColorProgressMap: Record<NotificationTypeEnumerated, string> = {
    [NotificationTypeEnumerated.SUCCESS]: '#4caf50',
    [NotificationTypeEnumerated.DANGER]: '#871212',
    [NotificationTypeEnumerated.INFO]: '#2196f3',
    [NotificationTypeEnumerated.WARNING]: '#ff9800',
  }

  return (
    <Modal
      open={open}
      onClose={() => onClose()}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
      sx={{ zIndex: 1700 }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: '40%', lg: '40%' },
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 2,
        }}
      >
        <Grid
          container
          spacing={2}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <Grid
            item
            xs={4}
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '10px',
            }}
          >
            <img
              src={typeToImageMap[type]}
              alt={type}
              style={{
                marginRight: '8px',
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Grid>

          <Grid
            item
            xs={8}
            style={{
              alignItems: 'center',
              paddingLeft: '16px',
              paddingTop: '50px',
            }}
          >
            <h2
              id='modal-title'
              className='mb-2 text-center'
              style={{
                textAlign: 'left',
                fontSize: '20px',
                color: typeToColorMap[type],
                marginBottom: '10px',
              }}
            >
              <b>{title}</b>
            </h2>
            <h2
              id='modal-title'
              style={{
                textAlign: 'left',
                fontSize: '14px',
                marginTop: '0',
                paddingTop: '0',
              }}
            >
              {text}
            </h2>
             <Grid item xs={12}
               style={{
                 marginBottom: '40px',
                 marginTop: '15px',
                 marginRight: '10px',
                 display: 'flex',
                 justifyContent: 'flex-end'
               }}>
               {duration > 0 ? (
                 <ProgressBar
                   duration={duration}
                   onComplete={onClose}
                   color={typeToColorProgressMap[type]}
                 />
               ) : (
                 <button
                   id="mp-modal-toast-ok"
                   onClick={onClose}
                   style={{
                     background: 'none',
                     border: 'none',
                     cursor: 'pointer',
                     display: 'flex',
                     alignItems: 'center',
                     gap: '8px',
                     padding: '0',
                     fontFamily: 'Arial, sans-serif'
                   }}
                 >
                   <Icon
                     path={mdiThumbUp}
                     size={1.2}
                     color="#702826"
                   />
                   <span style={{
                     fontSize: '14px',
                     fontWeight: 'bold',
                     color: '#333333'
                   }}>
                     Ok, entendi.
                   </span>
                 </button>
               )}
             </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}

export default ModalToast
